import BaseAPI from './BaseAPI';

// The Square team-member roster mirrored into the `staffs` table, under
// /staffs. Distinct from AdminAPI (auth/staff → the users/admin accounts).
class StaffAPI extends BaseAPI {
  constructor() {
    super('staffs');
  }

  list(status = 'all') {
    return this.get('/?status=' + status);
  }

  // POST /staffs/sync → { staffs: [...] } (refetches the roster from Square)
  sync() {
    return this.post('/sync');
  }
}

export const StaffService = new StaffAPI();
export default StaffAPI;
